interface RichTextProps {
  content?: string;
}

export function RichTextBlock({ props }: { props: RichTextProps }) {
  // Content is admin-authored CMS content, not user input
  if (!props.content) return null;
  return (
    <div
      className="prose prose-zinc max-w-none"
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}
